// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uxp_wd-field{width:100%;height:auto;position:relative}.uxp_wd-field .uxp_wd-field__remover{position:absolute;top:0;right:0;translate:50% -50%;width:20px;height:20px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;background-color:#000;color:#fff}.uxp_wd-field .uxp_wd-field__remover svg{width:50%;height:50%}", ""]);
// Exports
module.exports = exports;
